import { render, staticRenderFns } from "./vSelect.vue?vue&type=template&id=4d72c547&"
import script from "./vSelect.vue?vue&type=script&lang=js&"
export * from "./vSelect.vue?vue&type=script&lang=js&"
import style0 from "./vSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports